import { openOffcanvasCategory } from './offcanvas';

$(() => {
  const megamenuToggle = $('.header-catalog-toggle');
  const megamenuContainer = $('#megamenu');
  const megamenuChildren = $(megamenuContainer).find('.megamenu-nav-item');
  const oldButtonText = $(megamenuToggle).find('span').html();

  function initSwiper($subnav) {
    $subnav.find('.swiper-navigation').css('display', 'flex');
    const $slides = $subnav.find('.swiper-mega .swiper-slide');
    const isXlQuery = window.matchMedia('(min-width: 1281px)').matches;
    if (($slides.length > 3 && isXlQuery) || ($slides.length > 2 && !isXlQuery)) {
      new Swiper($subnav.find('.swiper-mega'), {
        cssMode: true,
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpointsInverse: true,
        freeMode: true,
        autoHeight: true,
        grabCursor: true,
        breakpoints: {
          781: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1281: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },

        navigation: {
          nextEl: $subnav.find('.swiper-button-next'),
          prevEl: $subnav.find('.swiper-button-prev'),
        },
      });
    } else {
      $subnav.find('.swiper-navigation').css('display', 'none');
    }
  }

  function destroySwiper($target) {
    $target.find('.swiper-pagination,.swiper-button-next,.swiper-button-prev,.swiper-scrollbar').removeClass('activeSwipe');
    $target.find('.swiper-mega').each((_, slider) => {
      if ($(slider).hasClass('swiper-container-horizontal')) {
        slider.swiper.destroy(true, true);
      }
    });
  }

  function openMegamenu() {
    $('body').addClass('megamenu-open');
    $(megamenuToggle).addClass('is-active');
    $(megamenuContainer).addClass('is-animate is-open');
    $(megamenuToggle).find('span').html('Закрыть');

    const $first = megamenuContainer.find('.megamenu-nav-item.active') ?? megamenuContainer.find('.megamenu-nav-item:first-child');
    $first.addClass('is-hover');
    initSwiper($first);
  }

  function closeMegamenu() {
    $('body').removeClass('megamenu-open');
    $(megamenuToggle).removeClass('is-active');
    $(megamenuContainer).removeClass('is-open');
    $(megamenuToggle).find('span').html(oldButtonText);
  }

  $(megamenuToggle).on('click', () => {
    setTimeout(() => {
      if (windowSizeHelper.isMobile()) {
        openOffcanvasCategory();
      } else if (!$(megamenuToggle).hasClass('is-active')) {
        openMegamenu();
        $(document).mouseup((e) => {
          if (!megamenuContainer.is(e.target) && megamenuContainer.has(e.target).length === 0) {
            closeMegamenu();
            $(document).off('mouseup');
          }
        });
      }
    }, 0);
  });

  $(megamenuChildren).on('mouseover', (e) => {
    const target = $(e.currentTarget);

    $(megamenuChildren).removeClass('is-hover');
    $(target).addClass('is-hover');

    if ($(e.target).hasClass('megamenu-nav-link')) {
      destroySwiper($(megamenuChildren));
      initSwiper(target);
    }
  });
});
